// import { useState } from 'react';
// import { Configuration, OpenAIApi } from 'openai';


// const configuration = new Configuration({
//   apiKey: process.env.REACT_APP_OPENAI_API_KEY,
// });
// const openai = new OpenAIApi(configuration);

// export default function AIImageGenerator() {

//   const [content, setContent] = useState('');
//   const [imageUrl, setImageUrl] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [history, setHistory] = useState([]);
//   const [style, setStyle] = useState('realistic');
//   const [size, setSize] = useState('512x512');


//   const styles = [
//     { value: 'realistic', label: 'Realistic', prompt: 'highly detailed realistic photography' },
//     { value: 'cartoon', label: 'Cartoon', prompt: 'colorful cartoon style, Pixar animation' },
//     { value: 'anime', label: 'Anime', prompt: 'anime art style, Studio Ghibli' },
//     { value: 'watercolor', label: 'Watercolor', prompt: 'watercolor painting style' },
//     { value: 'pixel-art', label: 'Pixel Art', prompt: '8-bit pixel art style' }
//   ];

//   const sizes = [
//     { value: '256x256', label: 'Small (256x256)' },
//     { value: '512x512', label: 'Medium (512x512)' },
//     { value: '1024x1024', label: 'Large (1024x1024)' }
//   ];


//   const generateImage = async (e) => {
//     e.preventDefault();
//     if (!content.trim()) {
//       setError('Please enter a description');
//       return;
//     }

//     setIsLoading(true);
//     setError(null);

//     try {
 
//       const selectedStyle = styles.find(s => s.value === style);
//       const enhancedPrompt = `${content}, ${selectedStyle.prompt}`;

//       const response = await openai.createImage({
//         prompt: enhancedPrompt,
//         n: 1,
//         size: size,
//       });
      
//       const generatedUrl = response.data.data[0].url;
      
//       setImageUrl(generatedUrl);
//       setHistory(prev => [
//         ...prev,
//         {
//           prompt: content,
//           enhancedPrompt: enhancedPrompt,
//           date: new Date().toLocaleString(),
//           imageUrl: generatedUrl,
//           style: selectedStyle.label,
//           size
//         }
//       ]);
//     } catch (err) {
//       console.error('DALL-E Error:', err.response?.data || err.message);
//       setError(err.response?.data?.error?.message || 'Failed to generate image. Please try again.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const downloadImage = () => {
//     if (!imageUrl) return;
    
//     const link = document.createElement('a');
//     link.href = imageUrl;
//     link.download = `ai-image-${Date.now()}.jpg`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   return (
//     <div className="app">
//       <header>
//         <h1>AI Image Generator</h1>
//         <p>Turn your text into stunning images with DALL-E</p>
//       </header>

//       <main>
//         <div className="generator-container">
//           <form onSubmit={generateImage} className="input-form">
//             <div className="form-group">
//               <label htmlFor="prompt">Describe the image you want:</label>
//               <textarea
//                 id="prompt"
//                 value={content}
//                 onChange={(e) => setContent(e.target.value)}
//                 placeholder="e.g. 'A sunset over mountains with a lake in the foreground'"
//                 rows="5"
//               />
//             </div>

//             <div className="options-row">
//               <div className="form-group">
//                 <label htmlFor="style">Style:</label>
//                 <select
//                   id="style"
//                   value={style}
//                   onChange={(e) => setStyle(e.target.value)}
//                 >
//                   {styles.map((option) => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="form-group">
//                 <label htmlFor="size">Size:</label>
//                 <select
//                   id="size"
//                   value={size}
//                   onChange={(e) => setSize(e.target.value)}
//                 >
//                   {sizes.map((option) => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <button type="submit" disabled={isLoading}>
//               {isLoading ? 'Generating...' : 'Generate Image'}
//             </button>
//           </form>

//           <div className="image-display">
//             {isLoading && (
//               <div className="loading">
//                 <div className="spinner"></div>
//                 <p>Creating your artwork...</p>
//               </div>
//             )}

//             {error && <div className="error">{error}</div>}

//             {imageUrl && !isLoading && (
//               <>
//                 <img src={imageUrl} alt="Generated from your description" />
//                 <button onClick={downloadImage} className="download-btn">
//                   Download Image
//                 </button>
//               </>
//             )}
//           </div>
//         </div>

//         {history.length > 0 && (
//           <div className="history-section">
//             <h2>Your Generation History</h2>
//             <div className="history-grid">
//               {history.slice().reverse().map((item, index) => (
//                 <div key={index} className="history-item">
//                   <img 
//                     src={item.imageUrl} 
//                     alt={`Generated: ${item.prompt}`} 
//                     onClick={() => setImageUrl(item.imageUrl)}
//                   />
//                   <p className="history-prompt">{item.prompt}</p>
//                   <p className="history-meta">{item.style} • {item.size} • {item.date}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </main>

//       <footer>
//         <p>AI Image Generator - Powered by DALL-E and React.js</p>
//       </footer>
//     </div>
//   );
// }


// const styles = `
// /* Base Styles */
// :root {
//   --primary-color: #4361ee;
//   --secondary-color: #3f37c9;
//   --dark-color: #1a1a2e;
//   --light-color: #f8f9fa;
//   --success-color: #4cc9f0;
//   --error-color: #f72585;
// }

// * {
//   box-sizing: border-box;
//   margin: 0;
//   padding: 0;
// }

// body {
//   font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
//   line-height: 1.6;
//   background-color: #f5f5f5;
//   color: #333;
// }

// .app {
//   max-width: 1200px;
//   margin: 0 auto;
//   padding: 20px;
//   min-height: 100vh;
//   display: flex;
//   flex-direction: column;
// }

// header {
//   text-align: center;
//   margin-bottom: 30px;
// }

// header h1 {
//   color: var(--primary-color);
//   margin-bottom: 10px;
// }

// /* Main Content */
// main {
//   flex: 1;
// }

// .generator-container {
//   display: flex;
//   flex-wrap: wrap;
//   gap: 30px;
//   margin-bottom: 40px;
// }

// .input-form {
//   flex: 1;
//   min-width: 300px;
// }

// .form-group {
//   margin-bottom: 20px;
// }

// .form-group label {
//   display: block;
//   margin-bottom: 8px;
//   font-weight: 600;
//   color: var(--dark-color);
// }

// .form-group textarea {
//   width: 100%;
//   padding: 12px;
//   border: 1px solid #ddd;
//   border-radius: 6px;
//   font-size: 16px;
//   resize: vertical;
//   min-height: 150px;
// }

// .form-group select {
//   width: 100%;
//   padding: 10px;
//   border: 1px solid #ddd;
//   border-radius: 6px;
//   font-size: 16px;
// }

// .options-row {
//   display: flex;
//   gap: 15px;
// }

// .options-row .form-group {
//   flex: 1;
// }

// button {
//   background-color: var(--primary-color);
//   color: white;
//   border: none;
//   padding: 12px 20px;
//   border-radius: 6px;
//   cursor: pointer;
//   font-size: 16px;
//   font-weight: 600;
//   transition: background-color 0.3s;
//   width: 100%;
// }

// button:hover {
//   background-color: var(--secondary-color);
// }

// button:disabled {
//   background-color: #ccc;
//   cursor: not-allowed;
// }

// .download-btn {
//   margin-top: 15px;
//   background-color: var(--success-color);
// }

// .download-btn:hover {
//   background-color: #3aa8d8;
// }

// /* Image Display */
// .image-display {
//   flex: 1;
//   min-width: 300px;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
// }

// .image-display img {
//   max-width: 100%;
//   max-height: 500px;
//   border-radius: 8px;
//   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
// }

// .loading {
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   height: 300px;
// }

// .spinner {
//   border: 5px solid rgba(0, 0, 0, 0.1);
//   border-radius: 50%;
//   border-top: 5px solid var(--primary-color);
//   width: 50px;
//   height: 50px;
//   animation: spin 1s linear infinite;
//   margin-bottom: 20px;
// }

// @keyframes spin {
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// }

// .error {
//   color: var(--error-color);
//   padding: 15px;
//   background-color: #ffeef2;
//   border-radius: 6px;
//   margin: 20px 0;
//   text-align: center;
// }

// /* History Section */
// .history-section {
//   margin-top: 40px;
// }

// .history-section h2 {
//   margin-bottom: 20px;
//   color: var(--dark-color);
//   border-bottom: 2px solid #eee;
//   padding-bottom: 10px;
// }

// .history-grid {
//   display: grid;
//   grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
//   gap: 20px;
// }

// .history-item {
//   background: white;
//   border-radius: 8px;
//   overflow: hidden;
//   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
//   transition: transform 0.3s;
// }

// .history-item:hover {
//   transform: translateY(-5px);
// }

// .history-item img {
//   width: 100%;
//   height: 150px;
//   object-fit: cover;
//   cursor: pointer;
// }

// .history-prompt {
//   padding: 10px;
//   font-size: 14px;
//   font-weight: 500;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
// }

// .history-meta {
//   padding: 0 10px 10px;
//   font-size: 12px;
//   color: #666;
// }

// /* Footer */
// footer {
//   text-align: center;
//   margin-top: 40px;
//   padding: 20px;
//   color: #666;
//   border-top: 1px solid #eee;
// }

// /* Responsive Design */
// @media (max-width: 768px) {
//   .generator-container {
//     flex-direction: column;
//   }
  
//   .options-row {
//     flex-direction: column;
//   }
// }
// `;


// document.head.insertAdjacentHTML('beforeend', `<style>${styles}</style>`);

import { useState } from "react";
import OpenAI from "openai";

// Initialize OpenAI client
const openai = new OpenAI({
  apiKey: process.env.REACT_APP_OPENAI_API_KEY,
  dangerouslyAllowBrowser: true, // needed for React
});

export default function AIImageGenerator() {
  // State
  const [content, setContent] = useState("");
  const [imageUrl, setImageUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [history, setHistory] = useState([]);
  const [style, setStyle] = useState("realistic");
  const [size, setSize] = useState("512x512");

  // Styles
  const styles = [
    { value: "realistic", label: "Realistic", prompt: "highly detailed realistic photography" },
    { value: "cartoon", label: "Cartoon", prompt: "colorful cartoon style, Pixar animation" },
    { value: "anime", label: "Anime", prompt: "anime art style, Studio Ghibli" },
    { value: "watercolor", label: "Watercolor", prompt: "watercolor painting style" },
    { value: "pixel-art", label: "Pixel Art", prompt: "8-bit pixel art style" },
  ];

  // Size Options
  const sizes = [
    { value: "256x256", label: "Small (256x256)" },
    { value: "512x512", label: "Medium (512x512)" },
    { value: "1024x1024", label: "Large (1024x1024)" },
  ];

  // Generate Image
  const generateImage = async (e) => {
    e.preventDefault();

    if (!content.trim()) {
      setError("Please enter a description");
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const selectedStyle = styles.find((s) => s.value === style);
      const enhancedPrompt = `${content}, ${selectedStyle.prompt}`;

      // NEW OpenAI Image API
      const response = await openai.images.generate({
        model: "gpt-image-1",
        prompt: enhancedPrompt,
        size: size,
      });

      const generatedUrl = response.data[0].url;

      setImageUrl(generatedUrl);

      // Save to history
      setHistory((prev) => [
        ...prev,
        {
          prompt: content,
          enhancedPrompt,
          date: new Date().toLocaleString(),
          imageUrl: generatedUrl,
          style: selectedStyle.label,
          size,
        },
      ]);

    } catch (err) {
      console.error("Image Error:", err);
      setError("Failed to generate image. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  // Download Image
  const downloadImage = () => {
    if (!imageUrl) return;

    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = `ai-image-${Date.now()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="app">

      <header>
        <h1>AI Image Generator</h1>
        <p>Turn your text into stunning images using OpenAI</p>
      </header>

      <main>
        <div className="generator-container">

          {/* Form */}
          <form onSubmit={generateImage} className="input-form">

            <div className="form-group">
              <label>Description:</label>
              <textarea
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Describe your image..."
                rows="5"
              />
            </div>

            <div className="options-row">

              <div className="form-group">
                <label>Style:</label>
                <select value={style} onChange={(e) => setStyle(e.target.value)}>
                  {styles.map((s) => (
                    <option key={s.value} value={s.value}>
                      {s.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Size:</label>
                <select value={size} onChange={(e) => setSize(e.target.value)}>
                  {sizes.map((s) => (
                    <option key={s.value} value={s.value}>
                      {s.label}
                    </option>
                  ))}
                </select>
              </div>

            </div>

            <button type="submit" disabled={isLoading}>
              {isLoading ? "Generating..." : "Generate Image"}
            </button>
          </form>

          {/* Image Display */}
          <div className="image-display">
            {isLoading && (
              <div className="loading">
                <div className="spinner"></div>
                <p>Creating your artwork...</p>
              </div>
            )}

            {error && <div className="error">{error}</div>}

            {imageUrl && !isLoading && (
              <>
                <img src={imageUrl} alt="Generated AI Art" />
                <button onClick={downloadImage} className="download-btn">
                  Download Image
                </button>
              </>
            )}
          </div>
        </div>

        {/* History Section */}
        {history.length > 0 && (
          <div className="history-section">
            <h2>Your Image History</h2>

            <div className="history-grid">
              {history
                .slice()
                .reverse()
                .map((item, index) => (
                  <div key={index} className="history-item">
                    <img
                      src={item.imageUrl}
                      alt={item.prompt}
                      onClick={() => setImageUrl(item.imageUrl)}
                    />
                    <p className="history-prompt">{item.prompt}</p>
                    <p className="history-meta">
                      {item.style} • {item.size} • {item.date}
                    </p>
                  </div>
                ))}
            </div>
          </div>
        )}
      </main>

      <footer>
        <p>AI Image Generator - Powered by OpenAI & React</p>
      </footer>
    </div>
  );
}
